import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceShareLinkCopySuccess: {
        id: "app.spaces.actions.shareLink.copy.success.text",
        defaultMessage: "Link successfully copied to clipboard.",
    },
    spaceShareLinkError: {
        id: "app.spaces.actions.shareLink.error.text",
        defaultMessage: "Error while creating space link.",
    },
    spaceShareLinkTitle: {
        id: "app.spaces.actions.shareLink.title.text",
        defaultMessage: "Share Link",
    },
    spaceShareLinkButton: {
        id: "app.spaces.actions.shareLink.button.text",
        defaultMessage: "Share Link",
    },
    spaceShareLinkCopyButton: {
        id: "app.spaces.actions.shareLink.copy.button.text",
        defaultMessage: "Copy Link",
    },
    spaceShareLinkPreviewButton: {
        id: "app.spaces.actions.shareLink.preview.button.text",
        defaultMessage: "Preview Link",
    },
    spaceShareLinkFormTracking: {
        id: "app.spaces.actions.shareLink.form.tracking.text",
        defaultMessage: "Tracking",
    },
    spaceShareLinkFormHideAddress: {
        id: "app.spaces.actions.shareLink.form.hideAddress.text",
        defaultMessage: "Hide Address",
    },
    spaceShareLinkFormProspect: {
        id: "app.spaces.actions.shareLink.form.prospect.text",
        defaultMessage: "Prospect Email",
    },
    spaceShareLinkFormToggleSwitchOn: {
        id: "app.spaces.actions.shareLink.form.toggleSwitchOn.text",
        defaultMessage: "On",
    },
    spaceShareLinkFormToggleSwitchOff: {
        id: "app.spaces.actions.shareLink.form.toggleSwitchOff.text",
        defaultMessage: "Off",
    },
    spaceShareLinkProspectError: {
        id: "app.spaces.actions.shareLink.form.prospect.error.text",
        defaultMessage: "Prospect email address is required if tracking is on.",
    },
});
export default messages;
